import { render, staticRenderFns } from "./ManageProfile.vue?vue&type=template&id=2821bf01&"
import script from "./ManageProfile.vue?vue&type=script&lang=js&"
export * from "./ManageProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports